module.exports = __webpack_public_path__ + "static/img/5624_phase_function_Paper_PointsHejduk_Prediction.c1c1d51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5624_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jzy3
// module chunks = 0